<template>
  <v-card>
    <v-card-text v-if="editModal">
      <a v-on:click="viewList()" class="white--text">
        <v-icon class="pr-2">chevron_left</v-icon>
      </a>
      Location Product - {{activeItem.name}}
    </v-card-text>
    <v-card-text v-else>Location Product List</v-card-text>
    <List v-if="!editModal" />
    <Edit v-if="editModal" />
    <New v-if="addModal" />
    <AssignCategory v-if="assignCategoryPop" />
    <product-card-dialog/>
    <ProductSelection v-if="productSelectionPopup" />

    <v-btn
      v-if="!editModal"
      @click="enableAddModal()"
      fixed
      depressed
      dark
      fab
      bottom
      right
      color="primary"
      :style="$root.rightNav?'margin-right:260px; margin-bottom:30px;':'margin-bottom:30px;'"
    >
      <v-icon dark>add</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import List from './List'
import Edit from './Edit'
import New from './New.vue'
import AssignCategory from './AssignCategory'
import ProductCardDialog from './ProductCardDialog.vue'
import ProductSelection from './ProductSelection.vue';
export default {
  components: {
    List,
    Edit,
    New,
    AssignCategory,
    ProductCardDialog,
    ProductSelection
},
  data() {
    return {
    }
  },
  mounted() {
    this.setEditPop(false)
    this.setAddPop(false)
    this.setAssignCategoryPop(false)
    this.setProductCardDialogValue(false)
    this.setActiveComponent('')
    this.setProductSelectionPopup(false)
  },
  computed: {
    ...mapGetters({
      editModal: 'locationproduct/editPop',
      addModal: 'locationproduct/addPop',
      activeItem: 'locationproduct/activeItem',
      assignCategoryPop: 'locationproduct/assignCatPop',
      productSelectionPopup: 'locationproduct/productSelectionPopup'
    })
  },
  methods: {
    enableAddModal() {
      this.setAddPop(true)
    },
    /**
     * Open List section
     */
    viewList() {
      this.setActiveComponent('ProductProfile')
      this.setEditPop(false)
      this.setSectionType('list')
      // this.setActiveItem({})
      // this.activateActionButtonAndSection(-1);
    },
    ...mapActions({
      setAddPop: 'locationproduct/setAddPop',
      setEditPop: 'locationproduct/setEditPop',
      setAssignCategoryPop: 'locationproduct/setAssignCatPop',
      setSectionType: 'locationproduct/setSectionType',
      setActiveComponent: 'locationproduct/setActiveComponent',
      setProductCardDialogValue: 'locationproduct/setProductCardDialogValue',
      setProductSelectionPopup: 'locationproduct/setProductSelectionPopup'
    })
  }
}
</script>
